export default __webpack_public_path__ + "static/media/setting_3.57b7bece.png";